import React from 'react';
import styled from 'styled-components';
import Drawer from './common/Drawer';
import GenerateForm from './common/GenerateForm';

type RecentMessagesDrawerProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (text: string) => void;
  onUpdate: (text: string) => void;
  generatedMessage?: string;
  loading: boolean;
};

const TextBlock = styled.div`
  margin-bottom: 20px;
`;

const RecentMessagesDrawer = ({
  open,
  onClose,
  onSubmit,
  onUpdate,
  generatedMessage,
  loading,
}: RecentMessagesDrawerProps) => {
  return (
    <Drawer header={'Generate a message'} open={open} onClose={() => onClose()}>
      <TextBlock>
        GPT will generate a message for your customer based on the last 15 messages between Bench
        and the customer.
      </TextBlock>
      <GenerateForm
        generatedMessage={generatedMessage}
        onSubmit={onSubmit}
        onUpdate={onUpdate}
        loading={loading}
      />
    </Drawer>
  );
};

export default RecentMessagesDrawer;
